module.exports = __webpack_public_path__ + "static/media/navidad5.e59368c4.webp";